<template>
	<div class="c-plan">
		<div class="plan-header" @click="fallback">
			<div class="header-title">			
				<i class="iconfont plan-back">&#xe613;</i>
				<span class="title">10月份计划</span>
			</div>
		</div>
		<router-view></router-view>
		<div class="create-plan-btn">
			<i class="iconfont plan-icon">&#xe603;</i>
			<p class="text">暂无计划</p>
			<router-link to="/insert-plan" tag="button" class="create-btn">
				创建计划
			</router-link>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import {fallback} from '@/assets/js/_mm.js'
	import VFooter from '@/pages/components/v-footer'
	export default {
		name: 'Home',
		components: {
			VFooter
		},
		methods: {
			fallback
		}
	}
</script>

<style lang="stylus" scoped>
	.c-plan
		width: 100%
		height: 100%
		background-color: #f2f2f2
		.plan-header
			display: flex
			justify-content: space-between
			height: 1.1rem
			padding: 0 .2rem 0 .4rem
			.header-title
				line-height: 1.1rem
				color: #1d1d1d
				font-size: .32rem
				.plan-back
					display: inline-block
					width: .64rem
					font-size: .42rem
				.title
					font-size: .36rem
			.header-select
				display: flex
				align-items: center
				.select-wrapper
					position: relative
					display: flex
					box-sizing: border-box
					align-items: center
					background-color: #ffffff
					border: 1px solid #666666
					&::after{
						position: absolute
						top: 0
						bottom: 0
						right: .48rem
						content: ""
						display: block
						width: 1px
						height: 100%
						background-color: #666666
					}
					.select
						padding: .02rem .32rem .02rem .16rem
						font-size: .3rem
					.arrow-bottom
						padding: 0 .1rem
						font-size: .26rem
		.create-plan-btn
			margin-top: 1.6rem
			text-align: center
			.plan-icon
				color: #cccccc
				font-size: 1.6rem
			.text
				margin: 0.32rem 0 1rem
				color: #cccccc
				font-size: .4rem
			.create-btn
				display: inline-block
				width: 3rem
				height: 1.2rem
				color: #4d0000
				border: 1px solid #944747;
				background-color: #ffb2b2
				border-radius: 0.12rem
</style>



// WEBPACK FOOTER //
// src/pages/c-plan/c-plan.vue